var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4479 18.4854L19.5765 16.3559C19.8632 16.0726 20.226 15.8787 20.6207 15.7977C21.0154 15.7167 21.4252 15.7521 21.8002 15.8996L24.3945 16.9358C24.7735 17.0897 25.0984 17.3524 25.3284 17.6907C25.5584 18.0291 25.6831 18.428 25.6869 18.8371V23.5905C25.6847 23.8688 25.6262 24.1438 25.5149 24.3989C25.4037 24.6541 25.242 24.884 25.0396 25.075C24.8371 25.266 24.5982 25.414 24.3371 25.5101C24.076 25.6062 23.7981 25.6485 23.5202 25.6344C5.34126 24.5031 1.67316 9.10229 0.979452 3.20814C0.94725 2.9187 0.976672 2.62571 1.06578 2.34846C1.1549 2.07121 1.30168 1.81598 1.49647 1.59955C1.69127 1.38312 1.92966 1.21041 2.19597 1.09278C2.46228 0.975139 2.75046 0.915244 3.04157 0.917031H7.63145C8.04103 0.918244 8.44089 1.04201 8.77958 1.27242C9.11828 1.50282 9.38033 1.82933 9.53202 2.20994L10.5678 4.80527C10.7201 5.17894 10.759 5.58923 10.6795 5.98487C10.6001 6.3805 10.4059 6.74396 10.1212 7.02983L7.99256 9.15933C7.99256 9.15933 9.21843 17.4587 17.4479 18.4854Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCel);
export default __webpack_public_path__ + "static/media/cel.8fdd0a6feebe3a884a977b66c4ac58b9.svg";
export { ForwardRef as ReactComponent };